import { SnackbarKey, VariantType } from 'notistack'

// action - customization reducer
export const SET_MENU = '@customization/SET_MENU'
export const MENU_TOGGLE = '@customization/MENU_TOGGLE'
export const MENU_OPEN = '@customization/MENU_OPEN'
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY'
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS'
export const SET_LAYOUT = '@customization/SET_LAYOUT '
export const SET_DARKMODE = '@customization/SET_DARKMODE'

// action - notifier reducer
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR'
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR'
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR'

// action - dialog reducer
export const SHOW_CONFIRM = 'SHOW_CONFIRM'
export const HIDE_CONFIRM = 'HIDE_CONFIRM'

export const SHOW_SIDEBAR = 'SHOW_SIDEBAR'

export type SnackbarEnqueueAction = {
  type: typeof ENQUEUE_SNACKBAR
  notification: {
    key: SnackbarKey
    message: string
    options?: NotificationOptions
  }
}

export type SnackbarCloseAction = {
  type: typeof CLOSE_SNACKBAR
  key?: SnackbarKey
  dismissAll?: boolean
}

export type SnackbarRemoveAction = {
  type: typeof REMOVE_SNACKBAR
  key: SnackbarKey
}

export type SnackbarAction = SnackbarEnqueueAction | SnackbarCloseAction | SnackbarRemoveAction

export type NotificationOptions = {
  key?: SnackbarKey
  variant: VariantType
  persist?: boolean
  dismissible?: boolean
}

export type NewSnackbarNotification = {
  message: string
  options?: NotificationOptions
}

export function enqueueSnackbar(notification: NewSnackbarNotification): SnackbarEnqueueAction {
  const key = notification.options?.key

  return {
    type: ENQUEUE_SNACKBAR,
    notification: {
      ...notification,
      key: key || new Date().getTime() + Math.random(),
    },
  }
}

export function closeSnackbar(key?: SnackbarKey): SnackbarCloseAction {
  return {
    type: CLOSE_SNACKBAR,
    dismissAll: !key, // dismiss all if no key has been defined
    key,
  }
}

export function removeSnackbar(key: SnackbarKey): SnackbarRemoveAction {
  return {
    type: REMOVE_SNACKBAR,
    key,
  }
}
